import { SET_GYM_SB } from "../constants";

let initialState = {
    users : [],
    selectedUser : null,
    gymSB: []
};

const userReducer = (state = initialState, action) => {

  switch (action.type) {
  
    case "SET_USERS" : 
      return {
        ...state,
        users : action.payload
      }   

    case "SET_SELECTED_USER" : 
      return {
        ...state,
        selectedUser : action.payload
      }      

    case SET_GYM_SB: {
      return {
        ...state,
        gymSB: action.payload
      }
    }
    
    default : return state
  }

}

export {userReducer}
